<div class="top-bar">
  <img class="logo" [src]="lviLogo">
</div>
<div class="main-wrap" *ngIf="failedToFindBooking">
  Failed to load booking information. Please try again later.
</div>
<div class="main-wrap" *ngIf="!failedToFindBooking">
  <p-card>
    <h2 i18n="welcome message to client" *ngIf="booking">
      Welcome, {{booking.lastName | titlecase}} {{booking.firstName | titlecase}}
    </h2>
    <br>
    <p i18n="step 1 of registration process for Bruges/VND">
      <strong>
        Step1:
      </strong>
      click "Vademecum form" and send informations about the participant
    </p>
    <p i18n="step 2 of registration process for Bruges/VND">
      <strong>
        Step2:
      </strong>
      upload a picture of participant (accepted file format: .png, .jpg, .jpeg)
    </p>
  </p-card>

  <div *ngIf="pictureUploadingError" class="error-message">
    <p i18n="picture uploading error message">Picture uploading error. Please try again later:</p>
    {{pictureUploadingError}}
  </div>
  <div *ngIf="imageSent">Success</div>
  <canvas #myCanvas height="16" *ngIf="!pictureUploaded">
    Sorry, your browser cannot display this image. Please upgrade to a modern browser.
  </canvas>
  <div *ngIf="booking">
    <div *ngIf="pictureUploading" i18n="uploading message">
      Uploading...
      <i class="pi pi-spin pi-spinner" style="font-size: 3em; color: rgb(0,0,255)"></i>
    </div>
    <p-card>
      <table>
        <tr>
          <td>
            <p i18n="vademecum">
              Form:
            </p>
          </td>
          <td>
            <p-button i18n-label="vademecum button" label="Form" *ngIf="!booking.hasVademecum"
              routerLink="/student-informations/{{booking.uuid}}"></p-button>
            <div *ngIf="booking.hasVademecum" class="vademecum-sent">
              <i class="pi pi-check" style="color: rgb(0, 255, 0)"></i>
              <p i18n="message to show when form is sent">Form sent</p>
            </div>

          </td>
        </tr>
        <tr>
          <td i18n="picture of student">
            <p>
              Picture
            </p>
          </td>
          <td>
            <div *ngIf="pictureUploaded" i18n="picture uploaded">
              <p>
                Picture uploaded
              </p>
              <i class="pi pi-check" style="color: rgb(0, 255, 0)"></i>
            </div>
            <div *ngIf="!pictureUploaded" i18n="upload a picture of student">
              <p class="upload-picture-text">
                upload a picture
              </p>
              <p-fileUpload [customUpload]="true" (uploadHandler)="uploadFile($event.files)"></p-fileUpload>
            </div>
          </td>
        </tr>
      </table>
    </p-card>
  </div>
</div>